"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StoryNodeOptions_1 = require("../../storyV2/domain/StoryNodeOptions");
const StudioProjectAttributesV3Node_1 = require("../../project/domain/StudioProjectAttributesV3Node");
const StudioProjectAttributesV3NodeData_1 = require("../../project/domain/StudioProjectAttributesV3NodeData");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class StoryNodeOptionsUtil {
    static from(params, isFromUIData) {
        if (!(params.data instanceof StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData)) {
            throw new Error("node data type is wrong");
        }
        const type = StoryNodeOptions_1.StoryNodeOptions.getNodeType(params.type ?? "");
        const displayType = StoryNodeOptions_1.StoryNodeOptions.getDisplayTypeType(params.data.displayType ?? "");
        const parentId = params.data.parentNodeId;
        let content;
        if (typeof params.data.textAreaValue === "object") {
            params.data.textAreaValue.fromUIData = isFromUIData;
            const jsonStr = JSON.stringify(params.data.textAreaValue);
            content = jsonStr;
        }
        else {
            content = params.data.textAreaValue;
        }
        return new StoryNodeOptions_1.StoryNodeOptions(params.id, content, type, displayType, parentId, params.data.childNode ?? [], params.data.inputTitle || "", params.data.generatedLabel || "");
    }
    static optionsToProjectNode(options, content) {
        const nodeData = new StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData();
        nodeData.parentNodeId = options.parentId;
        nodeData.childNode = options.children;
        nodeData.inputTitle = options.inputTitle;
        nodeData.generatedLabel = options.generatedLabel;
        nodeData.displayType = options.displayType;
        nodeData.textAreaValue = content;
        const node = new StudioProjectAttributesV3Node_1.StudioProjectAttributesV3Node();
        node.id = options.id;
        node.type = options.type;
        node.parentNode = options.parentId;
        node.data = nodeData;
        if (!(0, is_blank_1.default)(options.parentId)) {
            node.extent = "parent";
        }
        return node;
    }
}
exports.default = StoryNodeOptionsUtil;
